export default __webpack_public_path__ + "static/media/FAQ_1_3.53301f3e.png";